module.exports = __webpack_public_path__ + "static/media/edwin-s.2df579d2.png";